/**
 *
 * SelectModal
 *
 */
import React, { memo } from 'react';
import { ReactComponent as Close } from 'assets/icons/Close.svg';

import Modal from 'react-modal';
import { Button } from 'core/components/Button';
import { useDispatch } from 'react-redux';
// import { zIndex } from 'html2canvas/dist/types/css/property-descriptors/z-index';

interface Props {
  showModal: boolean;
  heading: string;
  subHeading?: string;
  actionToDispatch: any;
  setshowModal: any;
  payload?: any;
  setPayload: React.Dispatch<any>;
  callOnCancel?: (id?: number) => void;
  callOnSuccess?: () => void;
  callbackAfterSubmit?: any;
  submitLabel?: string;
  hideSubmitButton?: boolean;
}

export const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '30rem',
    minHeight: '10rem',
    borderRadius: '1.5em',
    boxShadow: '0px 16px 32px 4px rgba(0, 0, 0, 0.15)',
    padding: '1.3em',
    zIndex: 1000
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
    zIndex: 1000,
  },
};

export const SelectModal = memo((props: Props) => {
  const dispatch = useDispatch();

  const handleCancelOrClose = () => {
    if (props.callOnCancel) {
      props.callOnCancel(props.payload?.id);
    }
    props.setshowModal(false);
    if (!props?.callOnSuccess) {
      props.setPayload(undefined);
    }
  };

  return props.payload ? (
    <Modal
      isOpen={props.showModal}
      contentLabel="Example Modal"
      style={customStyles}
    >
      <div className="flex justify-between">
        <h1 className="font-bold text-xl">{props.heading}</h1>
        <Close
          className="w-6 h-6 cursor-pointer"
          onClick={handleCancelOrClose}
        // onClick={() => {
        //   if (props.callOnCancel) props.callOnCancel();
        //   props.setshowModal(false);
        //   props.setPayload(undefined);
        // }}
        />
      </div>
      <p className="text-medium text-md text-neutral-70 my-[1.5em]">
        {props.subHeading || 'Are you sure you want to delete this entry?'}
      </p>
      <div className="flex justify-end">
        <div className="flex gap-2">
          <Button
            button
            type="ghost"
            label="Cancel"
            onClick={handleCancelOrClose}
          // onClick={() => {
          //   if (props.callOnCancel) props.callOnCancel();
          //   props?.setshowModal(false);
          //   props?.setPayload(undefined);
          // }}
          />
          {!props?.hideSubmitButton && <Button
            button
            type="primary"
            label={props.submitLabel || 'Delete'}
            onClick={() => {
              dispatch(props.actionToDispatch(props.payload));
              props.setshowModal(false);
              if (props.callbackAfterSubmit)
                props.callbackAfterSubmit(props.payload.index);
              if (!!props?.callOnSuccess) {
                props?.callOnSuccess();
              } else {
                props.setPayload(undefined);
              }
            }}
          />}
        </div>
      </div>
    </Modal>
  ) : (
    <></>
  );
});
